import { render, staticRenderFns } from "./UserBadge.vue?vue&type=template&id=4c3d8cdf&scoped=true&"
import script from "./UserBadge.vue?vue&type=script&lang=js&"
export * from "./UserBadge.vue?vue&type=script&lang=js&"
import style0 from "./UserBadge.vue?vue&type=style&index=0&id=4c3d8cdf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3d8cdf",
  null
  
)

export default component.exports